export const BW_CHAT_BUNDLE_URL =
  process.env.REACT_APP_BW_CHAT_BUNDLE_URL || process.env.NEXT_PUBLIC_BW_CHAT_BUNDLE_URL;
export const BW_CHAT_BOT_ID = 'bwChatBotId';
export const BW_CHAT_SCRIPT_ID = 'bwChatScriptId';
